import React from "react";
import ReactDOM from "react-dom";

const RESERVED_WORDS = ["key", "ref"];

export function asMarionetteView(
    WrappedComponent,
    opts = {},
    viewClass = Backbone.Marionette.View,
) {

    return class MarionetteAdapter extends viewClass.extend(opts) {

        initialize(options) {
            this.options = options || {};
            this.options.view = this;
            const violatingOptions = RESERVED_WORDS
                .filter(w => this.options.hasOwnProperty(w));
            if (violatingOptions.length) {
                throw new Error(
                    `Reserved words were found in options: ${violatingOptions}. Please rename them.`,
                );
            }
        }

        render() {
            this.el.dataset.wrappedReactComponent = WrappedComponent.displayName || WrappedComponent.name || "Component";
            ReactDOM.render(<WrappedComponent {...this.options} />, this.el);
        }

        onBeforeClose() {
            ReactDOM.unmountComponentAtNode(this.el);
        }

    };

}



// WEBPACK FOOTER //
// ./app/lib/common/hoc/BackboneReact/asMarionetteView.js